// -------------------------------------
// Hamburger Active
// -------------------------------------
(function($) {
  "use strict"

  var $hamburger = $(".hamburger");
  $hamburger.on("click", function(e) {
    $hamburger.toggleClass("is-active");
  });

})(jQuery);